import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {InstagramComponent}  from './instagram.component'
import {CalendarComponent}  from './calendar.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'fbAuth',  component    :InstagramComponent },
      { path: 'calendar',  component    :CalendarComponent }

    ])
  ]
})
export class InstagramRoutingModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+integrationCode/instagram.routing.ts